import { render } from "./footer_1.vue?vue&type=template&id=4b4bb0f6"
import script from "./footer_1.vue?vue&type=script&lang=js"
export * from "./footer_1.vue?vue&type=script&lang=js"

import "./footer_1.vue?vue&type=style&index=0&id=4b4bb0f6&lang=css"
script.render = render

export default script